import { configureStore } from "@reduxjs/toolkit";
import uiReducer from "./Slices/Ui";
import userReducer from "./Slices/User";

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    user: userReducer,
  },
});
